import { HttpResourceRef } from '@angular/common/http';
import { Injector, Signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export abstract class AdvancedFilterApiMatcher {
  abstract idValidationResource: HttpResourceRef<unknown>;
  abstract label: Signal<string>;
  protected readonly translate = this.injector.get(TranslateService);

  constructor(
    public readonly id: number,
    public readonly inUseApiFilters: Signal<Record<string, number>>,
    protected readonly injector: Injector,
  ) {}

  public isInvalid(): boolean | null {
    if (this.idValidationResource.status() === 'loading' || this.idValidationResource.status() === 'idle') {
      return null;
    }

    return this.idValidationResource.status() === 'error' || !this.validateDependencies();
  }

  public validateDependencies(): boolean {
    return true;
  }
}
